/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

import arrow from '../../assets/images/arrow_icon.svg';

export const createProductsListStyles = makeStyles((theme: Theme) => ({
  root: {
    marginBottom: '24px',
  },
  list: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
    wordBreak: 'break-word',
  },
  title: {
    margin: '8px 0 12px 0',
  },
  card: {
    display: 'inline-flex',
    flexDirection: 'column',
    padding: '20px 10px 10px',
    border: '1px solid #EEE',
    borderRadius: '12px',
    width: '280px',
    minHeight: '153px',
    height: '100%',
  },
  cardRow: {
    margin: '0 10px 20px',
    '&:last-child': {
      margin: '0 10px 14px',
    },
  },
  cardProductRow: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  cardCell: {
    display: 'flex',
    alignItems: 'baseline',
  },
  cardRowTitle: {
    margin: '0 0 8px',
    fontSize: '13px',
    lineHeight: '13px',
  },
  cardRowValue: {
    color: theme.palette.primary.main,
    fontSize: '32px',
    lineHeight: '32px',
    letterSpacing: '-0.64px',
    fontWeight: 700,
    paddingRight: '4px',
  },
  cardRowKey: {
    fontSize: '14px',
    lineHeight: '14px',
    letterSpacing: '-0.11px',
    fontWeight: 400,
    wordBreak: 'keep-all',
  },

  itemRoot: {
    padding: '10px',
    paddingLeft: '48px',
    marginTop: 'auto',
    borderRadius: '12px',
    minHeight: '52px',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    cursor: 'pointer',
    textAlign: 'left',
    width: '100%',
    justifyContent: 'flex-start',
    transition: 'all .2s linear',
    '&:hover': {
      backgroundColor: `${theme.palette.primary.main}10`,
    },
    '&:hover > $itemIconArrow': {
      opacity: '1',
    },
    '&.itemNoIcon': {
      paddingLeft: '18px',
    },
  },
  itemIcon: {
    width: '24px',
    height: '24px',
    overflow: 'hidden',
    borderRadius: '6px',
    position: 'absolute',
    left: '14px',
    top: '50%',
    transform: 'translateY(-50%)',
    '& img': {
      width: '100%',
      height: '100%',
    },
    '& > svg': {
      width: '100%',
      height: '100%',
    },
  },
  itemText: {
    flex: '1 1 auto',
    maxWidth: '100%',
    fontSize: '14px',
    lineHeight: '18px',
    textAlign: 'left',
    paddingRight: '10px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  itemIconArrow: {
    backgroundImage: `url('${arrow}')`,
    backgroundColor: theme.palette.primary.main,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    borderRadius: '6px',
    width: '32px',
    height: '32px',
    opacity: '0',
    transition: 'opacity .2s linear',
    flex: '0 0 auto',
  },
}));
